import type { OrgUserDTO } from '@/types/organization.dtos';
import type { UserRow } from '@/types/users.types';
import { normalizeOrgUserStatus, normalizeUserType } from '@/store/mappers/normalizers';

/**
 * Maps OrgUserDTO[] → UserRow[]
 * Applies normalization strategies for status and userType.
 */
export function mapOrgUserDTOsToRows(dtos: OrgUserDTO[]): UserRow[] {
  return dtos.map((dto): UserRow => ({
    id: dto.id,
    name: dto.name,
    email: dto.email,
    phone: dto.phone,
    deptOrg: dto.deptOrg,
    status: normalizeOrgUserStatus(dto.status),
    userType: normalizeUserType(dto.userType),
  }));
}
